import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ReadonlyService } from '../services/readonly.service';

@Injectable({
  providedIn: 'root'
})
export class LockedEntityInterceptor implements HttpInterceptor {
  private readonlySvc = inject(ReadonlyService);


  private matchers: RegExp[] = [
    new RegExp(/(?:reports\/).{1,}/),
  ]


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    /*
      1. Se la richiesta fa match con almeno una regex devo controllare il body
      2. Se il documento ha l'attributo LOCKED === TRUE ==> readonly = true;
      3. Se il documento non ha l'attributo LOCKED ==> readonly = false;
      4. Se il documento ha l'attributo LOCKED === FALSE ==> reaonly = false;
    */
   return next.handle(req).pipe(
     tap((resp: any) => {
        const response: HttpResponse<any> = resp;
        const anyMatch = this.matchers.some(regex => regex.test(req.url));
        if(anyMatch && req.method.toLowerCase() === 'get' && resp.body) {
          this.readonlySvc.readonly = response.body?.locked === true
        }
      })
    );
  }


}
